(() => {
  const numberLabel = (value) => Number(value).toLocaleString('en-US', { maximumFractionDigits: 3 });

  function summarizeKilograms(raw) {
    const quantity = Number(raw.quantity);
    const packKilograms = Number(raw.packKilograms);
    const min = raw.min === '' || raw.min == null ? 1 : Number(raw.min);
    const step = raw.step === '' || raw.step == null ? 1 : Number(raw.step);
    const max = raw.max === '' || raw.max == null ? null : Number(raw.max);
    const invalid = !Number.isFinite(quantity) || !Number.isFinite(packKilograms) || !Number.isFinite(min) || !Number.isFinite(step)
      || quantity < min || packKilograms <= 0 || step <= 0 || (max != null && (!Number.isFinite(max) || quantity > max));
    const offset = invalid ? 0 : (quantity - min) / step;
    if (invalid || Math.abs(offset - Math.round(offset)) > 1e-9) {
      return { valid: false, text: 'Enter a valid pack quantity to see total kilograms.' };
    }
    const totalKilograms = quantity * packKilograms;
    if (!Number.isFinite(totalKilograms)) return { valid: false, text: 'Enter a valid pack quantity to see total kilograms.' };
    return {
      valid: true,
      quantity,
      packKilograms,
      totalKilograms,
      text: `${numberLabel(quantity)} ${quantity === 1 ? 'pack' : 'packs'} × ${numberLabel(packKilograms)} kg = ${numberLabel(totalKilograms)} kg total`
    };
  }

  globalThis.SagaOrderQuantity = Object.freeze({ summarizeKilograms });
})();
